var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89575 3.59564L1.74992 10.7415V12.25H3.25842L10.4043 5.10414L8.89575 3.59564ZM9.72058 2.77081L11.2291 4.27931L12.0084 3.49998L10.4999 1.99148L9.72058 2.77081ZM10.9123 0.754227L13.2457 3.08756C13.355 3.19695 13.4165 3.3453 13.4165 3.49998C13.4165 3.65466 13.355 3.803 13.2457 3.91239L3.91234 13.2457C3.80296 13.3551 3.65462 13.4166 3.49992 13.4166H1.16659C1.01188 13.4166 0.863503 13.3552 0.754106 13.2458C0.64471 13.1364 0.583252 12.988 0.583252 12.8333V10.5C0.583285 10.3453 0.644765 10.1969 0.754169 10.0876L10.0875 0.754227C10.1969 0.644869 10.3452 0.583435 10.4999 0.583435C10.6546 0.583435 10.8029 0.644869 10.9123 0.754227ZM12.8333 12.25C12.988 12.25 13.1363 12.3114 13.2457 12.4208C13.3551 12.5302 13.4166 12.6786 13.4166 12.8333C13.4166 12.988 13.3551 13.1364 13.2457 13.2458C13.1363 13.3552 12.988 13.4166 12.8333 13.4166H6.99992C6.84521 13.4166 6.69684 13.3552 6.58744 13.2458C6.47804 13.1364 6.41658 12.988 6.41658 12.8333C6.41658 12.6786 6.47804 12.5302 6.58744 12.4208C6.69684 12.3114 6.84521 12.25 6.99992 12.25H12.8333Z",
    fill: "#3B465F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7814f3e9d038489b9c3f95ea3865df47.svg";
export { ForwardRef as ReactComponent };